import { render, staticRenderFns } from "./comments_detial.vue?vue&type=template&id=45dbf948&scoped=true"
import script from "./comments_detial.vue?vue&type=script&lang=js"
export * from "./comments_detial.vue?vue&type=script&lang=js"
import style0 from "./comments_detial.vue?vue&type=style&index=0&id=45dbf948&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dbf948",
  null
  
)

export default component.exports